<template>
    <div v-if="takerGroup !== null" class="right-group-detail">
        <div class="page-title">Details</div>
        <div class="gcmcn-card-gradient">
            <div class="flex-space-between">
                <div class="details-title">{{ takerGroup.name }}</div>
                <div>
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn small edit-feed"
                        @click="editGroupTaker"
                    >Edit</el-button>
                    <el-popover
                        ref="popover"
                        placement="bottom"
                        width="142"
                        :trigger="'click'"
                        popper-class="dark-popper"
                        @hide="hideDeletePopover"
                    >
                        <div class="popover-title">Confirm group deletion</div>
                        <div class="actions">
                            <el-button type="text" class="decline" @click="hideDeletePopover()">No</el-button>
                            <el-button type="text" class="accept" @click="deleteGroup()">Yes</el-button>
                        </div>
                        <el-button
                            slot="reference"
                            type="danger"
                            class="gcmcn-danger-btn small"
                            :loading="loading"
                        >Delete</el-button>
                    </el-popover>
                </div>
            </div>
            <el-divider></el-divider>
            <gcmcn-filters
                :filter-values="[selectedSortType, searchFilter]"
                @reset-filters="resetFilters"
            >
                <dropdown
                    name="Sort"
                    :multiple="false"
                    :list="$store.getters.sortTypeList"
                    itemName="name"
                    itemValue="value"
                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                    @on-select-item="selectedSortType = $event"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <template v-if="filteredTakers.length > 0">
                <taker
                    v-for="taker in filteredTakers"
                    :key="taker.uid"
                    :taker="taker"
                    :taker-group="takerGroup"
                    @on-remove-taker-from-group="onRemoveTakerFromGroup"
                ></taker>
            </template>
            <template v-else>
                <div class="list-empty">No taker</div>
            </template>
        </div>
    </div>
</template>

<script>
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter,
} from 'gcmcn-common';
import Taker from './taker.vue';
export default {

    components: {
        GcmcnFilters,
        Dropdown,
        SearchFilter,
        Taker,
    },

    props: {
        takerGroup: {
            required: true,
            validator: prop => prop instanceof Object || prop === null,
        },
    },

    data (){
        return {
            selectedSortType: '',
            searchFilter: '',
            loading: false,
        };
    },

    computed: {
        filteredTakers (){
            let takers = this.takersFromGroup.slice();
            if(this.selectedSortType){
                takers.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    takers.reverse();
                }
            }
            if(this.searchFilter){
                takers = takers.filter((takerGr) => takerGr.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return takers;
        },

        takersFromGroup (){
            return this.$store.getters.takers.filter((taker) => this.takerGroup.takers_uid.includes(taker.uid));
        },
    },

    mounted (){
    },

    methods: {
        deleteGroup() {
            this.$store.dispatch('deleteItem', {
                item: this.takerGroup,
                model: 'takerGroups'
            }).then(() => {
                this.$message.success({
                    message: 'The group has been deleted'
                });
                this.$emit('on-group-deleted');
            }).catch(() => {
                this.$message.error({
                    message: 'The group couldn\'t be deleted'
                });
            });
        },
        hideDeletePopover() {
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
        editGroupTaker (){
            this.$emit('on-taker-group-update');
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        onRemoveTakerFromGroup (taker){
            let takerGroup = JSON.parse(JSON.stringify(this.takerGroup));
            let takers_uid = takerGroup.takers_uid;
            takers_uid.splice(takers_uid.indexOf(taker.uid), 1);
            this.$store.dispatch('patchItem', {
                item: takerGroup,
                model: 'takerGroups'
            }).then(() => {
                this.$message({
                    message: `Taker ${taker.name} successfully removed from ${this.takerGroup.name}!`,
                    type: 'success'
                });
            }).catch((e) => {
                console.error(e);
                this.$message.error(`Error while remove taker from group.`);
            });
        }
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/RightGroup/taker-group-details.vue